import events from './events';
import posts from './posts';
import users from './users';

export default {
  events,
  posts,
  users,
};
